exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1QGHEBQ6-index-module-footer{background-color:#fff;border-top-color:#f0f0f0;border-top-style:solid;border-top-width:2px;bottom:0;font-size:.875rem;height:45px;padding-top:10px;position:absolute;width:100%}._3w3zv1fZ-index-module-nav-item{display:inline;margin-right:10px}._3w3zv1fZ-index-module-nav-item:last-child{margin-right:0}", ""]);

// exports
exports.locals = {
	"primary": "#067370",
	"footer": "_1QGHEBQ6-index-module-footer",
	"nav-item": "_3w3zv1fZ-index-module-nav-item",
	"navItem": "_3w3zv1fZ-index-module-nav-item"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/layout/Footer/index.module.scss
// module id = 1206
// module chunks = 0